import { ReactElement, useEffect, useRef } from 'react';
import { getLabelFallback } from '@utils/utils';

const CVNPopup = (props) : ReactElement => {
    const ref = useRef(null);

    const {
        onClick
    } = props;

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
              onClick();
            }
          };
          document.addEventListener('click', handleClickOutside, true);
          return () => {
            document.removeEventListener('click', handleClickOutside, true);
          };
      }, []);

    return(
        <div ref={ref} className="cvn-popup">
            <div className="cvn-popup-content">
                <div>
                    {getLabelFallback('CVN_POPUP_TEXT_1')}
                </div>
                <div>
                    {getLabelFallback('CVN_POPUP_TEXT_2')}
                </div>
            </div>
        </div>
    );
}

export default CVNPopup;